import { BehaviorSubject, Observable } from "rxjs";
import * as rxjsOperators from "rxjs-operators";
import jwtDecode from "jwt-decode";

import storageService, { StorageService } from "./storage";

export class TokenService {
  private token$: BehaviorSubject<string>;

  constructor(private storageService: StorageService) {
    this.token$ = new BehaviorSubject(this.getTokenSync());
    this.storageService
      .get("authToken")
      .pipe(rxjsOperators.logError())
      .subscribe((token) => this.token$.next(token));
  }

  getTokenSync(): string {
    return localStorage.getItem("authToken");
  }

  public getToken(): Observable<string> {
    return this.token$.asObservable();
  }

  public setToken(token: string | null): Observable<string> {
    if (token === null) {
      return this.storageService.clear(/authToken/).pipe(
        rxjsOperators.switchMap(() => {
          this.token$.next(null);
          return this.getToken();
        })
      );
    }

    return this.storageService.set("authToken", token).pipe(
      rxjsOperators.switchMap(() => {
        this.token$.next(token);
        return this.getToken();
      })
    );
  }

  public clearToken(): Observable<void> {
    return this.setToken(null).pipe(rxjsOperators.map(() => null));
  }

  public decode<T>(token: string): T {
    if (token === "null") return null;

    try {
      return b64DecodeUnicode(token);
    } catch (err) {
      console.log("Token rejected, reason: ", err);
      return null;
    }
  }
}

function b64DecodeUnicode(token: string): any {
  return jwtDecode(token);
}

const tokenService = new TokenService(storageService);
export default tokenService;
